import { Box, HStack } from '@rbilabs/universal-components';

import { spacing } from 'styles/constants';

const FORM_SPACING = spacing.$1;

export const StyledExpiryCVVWrapper = HStack.withConfig({
  justifyContent: 'space-between',
  width: 'full',
});

export const StyledExpiryWrapper = Box.withConfig({
  marginRight: '$4',
  marginBottom: FORM_SPACING,
  width: '1/2',
});

export const StyledCvvWrapper = Box.withConfig({
  flexShrink: 1,
  flexGrow: 1,
  marginBottom: FORM_SPACING,
  width: '1/2',
});

export const CardNumberWrapper = Box.withConfig({
  position: 'relative',
  marginBottom: FORM_SPACING,
});
